import { useState } from "react";
import { Link } from "react-router-dom";
import { useCollection, PageHeader, CrudActions, Modal, Empty } from "../components/Crud";
import { Plus, GraduationCap } from "lucide-react";

export default function Classes() {
    const { items, create, update, remove } = useCollection("classes");
    const [open, setOpen] = useState(false);
    const [edit, setEdit] = useState(null);
    const blank = { name: "", code: "", lecturer_name: "", lecturer_email: "", lecturer_phone: "", lecturer_office: "", schedule: "", semester: "" };
    const [form, setForm] = useState(blank);
    const [q, setQ] = useState("");
    const filtered = items.filter(c => `${c.name} ${c.code}`.toLowerCase().includes(q.toLowerCase()));

    const submit = async (e) => { e.preventDefault(); if (edit) await update(edit.id, form); else await create(form); setOpen(false); setEdit(null); setForm(blank); };
    const startEdit = (c) => { setEdit(c); setForm({ ...blank, ...c }); setOpen(true); };

    return (
        <div data-testid="classes-page">
            <PageHeader title="Classes" subtitle="this semester" action={
                <button onClick={() => { setEdit(null); setForm(blank); setOpen(true); }}
                        data-testid="add-class-btn" className="btn-primary inline-flex items-center gap-2">
                    <Plus size={16} /> Add class
                </button>
            } />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search classes…"
                   data-testid="classes-search"
                   className="w-full max-w-sm mb-5 px-3 py-2 rounded-xl border border-[rgba(26,19,24,0.15)]" />
            {filtered.length === 0 ? (
                <Empty icon={GraduationCap} title="No classes yet" hint="Add a class to track lecturer info, assessments, projects, and a reading list." />
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {filtered.map((c) => (
                        <div key={c.id} className={`card-warm p-5 ${c.archived ? "opacity-60" : ""}`} data-testid={`class-card-${c.id}`}>
                            <div className="flex justify-between items-start gap-2">
                                <Link to={`/classes/${c.id}`} className="flex-1 min-w-0" data-testid={`open-class-${c.id}`}>
                                    <div className="font-script text-[var(--brand-orange)] text-lg">{c.code}</div>
                                    <div className="font-serif text-xl">{c.name}</div>
                                    <div className="text-xs text-[var(--text-ink)]/60 truncate mt-1">{c.lecturer_name}</div>
                                </Link>
                                <CrudActions idBase={`class-${c.id}`} onEdit={() => startEdit(c)}
                                    onArchive={() => update(c.id, { archived: !c.archived })}
                                    onDelete={() => window.confirm("Delete class?") && remove(c.id)}
                                    archived={c.archived} />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <Modal open={open} onClose={() => setOpen(false)} title={edit ? "Edit class" : "Add class"}>
                <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3" data-testid="class-form">
                    {[["name", "Class name *", true], ["code", "Course code"], ["lecturer_name", "Lecturer"],
                      ["lecturer_email", "Lecturer email"], ["lecturer_phone", "Lecturer phone"],
                      ["lecturer_office", "Office / Room"], ["schedule", "Schedule"], ["semester", "Semester"]].map(([k, l, req]) => (
                        <label key={k} className="text-sm">{l}
                            <input required={!!req} value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                data-testid={`class-input-${k}`} className="w-full mt-1 px-3 py-2 rounded-xl border border-[rgba(26,19,24,0.15)]" />
                        </label>
                    ))}
                    <div className="col-span-2 flex justify-end gap-2">
                        <button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button>
                        <button type="submit" data-testid="class-save-btn" className="btn-primary">Save</button>
                    </div>
                </form>
            </Modal>
        </div>
    );
}
